export default __webpack_public_path__ + "static/media/054-terms.64040af2.svg";